import dayjs from "dayjs";
import { filter } from "lodash";

export function filterDataByDate<T extends Record<string, any>>(
  data: T[],
  startDate: string | Date | null,
  endDate: string | Date | null,
  key: keyof T,
) {
  if (!endDate && !startDate) return data;

  return filter(data, (item) => {
    const isSameStartDate = dayjs(item[key]).isSame(startDate);
    const isSameEndDate = dayjs(item[key]).isSame(endDate);

    const isAfterStartDate = dayjs(item[key]).isAfter(startDate);
    const isBeforeEndDate = dayjs(item[key]).isBefore(endDate);

    return (
      isSameStartDate || (isAfterStartDate && isBeforeEndDate) || isSameEndDate
    );
  });
}
